module.exports = __webpack_public_path__ + "static/media/mark_austin-outrun-med.d6f7cb7b.png";